import React, { useEffect, useState } from "react";
import { CardComponent, ErrorMessage, UpgradeCard } from "../../../components";
import { useSelector, connect } from "react-redux";
import { toAbsoluteUrl } from "../../../services";

import {
  loadCampaigns,
  updateCampaignDate,
} from "../../../redux/actions/premium/dashboardActions";
import HelpButton from "../../../components/button/helpButton";

// get step data from redux main state
const data = (state) => state.premiumDashboard;
// get step data from redux main state
const authData = (state) => state.auth;
function Dashboard(props) {
  let client = useSelector(authData);
  let clientData = useSelector(data);
  const [upgrade, setUpgrade] = useState(false);
  let { startDate, endDate } = client?.campaignDates;

  let updateCampaignDate = (data) => {
    props.updateCampaignDate(data);
  };
  useEffect(() => {
    props.loadCampaigns();
  }, [props]);

  let updatePlan = () => {
    setUpgrade(!upgrade);
  };

  let onCloseUpgrade = () => {
    setUpgrade(!upgrade);
  };

  return (
    <div>
      <div className="flex 2xl:flex-row xl:flex-row lg:flex-row md:flex-row flex-col 2xl:justify-between xl:justify-between lg:justify-between md:justify-between items-center text-2xl 2xl:px-20 xl:px-20 lg:px-20 md:px-10 px-0  underline font-bold text-[#007e8b] pt-[3rem]">
        <p className="text-[#007E8C] font-semibold text-2xl">
          My Assessment Games
        </p>
        <p className="text-[#007E8C] font-semibold text-2xl">
          Total Number Of Games:{" "}
          {clientData ? clientData.campaigns && clientData.campaigns.length : 0}
        </p>
      </div>
      <div>
        {clientData && clientData.message ? (
          <div className="w-max mx-auto">
            <ErrorMessage
              text={clientData && clientData.message + ",  kindly reload page"}
            />
          </div>
        ) : null}
      </div>
      {clientData && clientData.loading ? (
        <div className="flex justify-center items-center my-[2rem]">
          <img
            src={toAbsoluteUrl("/media/dashboard/logo.gif")}
            alt="TTG LOGO"
            style={{
              width: "100px",
              height: "90px",
            }}
          />
        </div>
      ) : (
        <div
          className={`flex ${clientData && clientData.campaigns > 1
              ? "justify-center"
              : "justify-start"
            } pb-24 px-10`}
        >
          <div className="mt-[3rem]">
            <div className="wrapCard flex flex-wrap justify-start">
              {clientData && clientData.campaigns
                ? clientData &&
                clientData.campaigns.map((campaign, index) => (
                  <CardComponent
                    updateCampaignDate={updateCampaignDate}
                    campaign={campaign}
                    key={index}
                    userType={client ? client.userType : null}
                    maxDate={endDate}
                  />
                ))
                : null}
            </div>
          </div>
        </div>
      )}

      {upgrade ? (
        <UpgradeCard type="FREE" onCloseUpgrade={onCloseUpgrade} />
      ) : null}

      <div className="my-10 flex justify-between mt-[12rem]">
        <div></div>
        <div className="text-center">
          <h1 className="font-medium text-xl  text-[#3B4345]">
            Your Current Plan:{" "}
            <b className="font-bold text-xl text-[#007E8C]">PREMIUM</b>
          </h1>
        </div>
        <div></div>
      </div>
      <HelpButton screen="login" />
    </div>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  updateCampaignDate,
  loadCampaigns,
})(Dashboard);
